import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../../hooks/useAuth';
import './header.css';

const navigationItems = [
  { path: '/', title: 'Home' },
  { path: '/events', title: 'Events' },
  { path: '/sessions', title: 'Sessions' },
];

const getField = (item, ...keys) => {
  for (const key of keys) {
    if (item?.[key]) return item[key];
  }
  return undefined;
};

const getUserName = (user, userProfile) => {
  const profileName = getField(userProfile, 'full_name', 'fullName', 'name', 'username', 'email');
  if (profileName) return profileName;

  try {
    const parsed = JSON.parse(user);
    return getField(parsed, 'full_name', 'fullName', 'name', 'username', 'email') || 'User';
  } catch {
    return user || 'User';
  }
};

const getInitials = (name) => (
  String(name || 'User')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join('') || 'U'
);

export default function Header() {
  const { user, userProfile, logout } = useAuth();
  const location = useLocation();
  const userName = getUserName(user, userProfile);

  return (
    <header className="app-topnav">
      <div className="app-topnav-inner">
        <Link to="/" className="app-brand">
          <div className="app-brand-mark">T</div>
          <div className="app-brand-name">Transcript</div>
        </Link>

        <nav className="app-topnav-links" aria-label="Main navigation">
          {navigationItems.map(item => {
            const isActive = item.path === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(item.path);

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`app-topnav-link ${isActive ? 'active' : ''}`}
              >
                {item.title}
              </Link>
            );
          })}
        </nav>

        <div className="app-topnav-right">
          <Link
            to="/upload"
            className={`app-btn app-btn-primary app-btn-sm app-topnav-upload ${location.pathname.startsWith('/upload') ? 'active' : ''}`}
            aria-label="Upload transcript"
          >
            <ArrowUpTrayIcon className="app-topnav-upload-icon" aria-hidden="true" />
            <span>Upload</span>
          </Link>
          <div className="app-topnav-user">
            <div className="app-avatar">{getInitials(userName)}</div>
            <span className="app-topnav-user-name">{userName}</span>
          </div>
          <button className="app-btn app-btn-ghost app-btn-sm" type="button" onClick={logout}>
            Log out
          </button>
        </div>
      </div>
    </header>
  );
}
